<div class="privacy-view">
    <div class="privacy-text primary">
        <span>{{ "b2c.IDS_PRIVACY_TEXT" | translate }}</span>
    </div>
</div>
